<template>
    <Head :title="__('Create :resource', {resource: __('Role').toLowerCase()})"/>

    <BreezeDashboardLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                {{ __('Create :resource', {resource: __('Role').toLowerCase()}) }}
            </h2>
        </template>

        <card-component @submit.prevent="submit" form>

            <field class="max-w-sm" :label="__('Name')" :error="errors.name ?? ''">
                <control :icon="mdiAccount" :placeholder="__('Name')" v-model="form.name"
                         :required="true"/>
            </field>

            <field class="max-w-sm" :label="__('Guard name')" :error="errors.email ?? ''">
                <control :icon="mdiAccountChildCircle" :options="guard_name_options" v-model="form.guard_name"
                         :required="true"/>
            </field>

            <field class="max-w-sm" :label="__('Permissions')" :error="errors.permissions ?? ''">
                <check-radio-picker class="checkbox-block" type="checkbox mr-0"
                                    name="sample-checkbox"
                                    v-model="form.permissions"
                                    :options="userPermissions"
                />
            </field>

            <jb-buttons class="justify-end">
                <jb-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing"
                           type="success" color="success"
                           :label="__('Create :resource', {resource: __('Role').toLowerCase()})"/>
            </jb-buttons>
        </card-component>
    </BreezeDashboardLayout>
</template>

<style>
</style>

<script>
import BreezeDashboardLayout from '@/Layouts/Dashboard'
import CardComponent from '@/Components/Dashboard/CardComponent'
import Notification from '@/Components/Dashboard/Notification'
import {Head, usePage} from '@inertiajs/inertia-vue3';
import {
    mdiAt,
    mdiAccount,
    mdiAccountMultipleOutline,
    mdiEmail,
    mdiLink,
    mdiOpenInNew,
    mdiAccountChildCircle,
    mdiAvTimer,
    mdiTranslate,
    mdiNumeric8BoxMultipleOutline
} from '@mdi/js'
import Field from '@/Components/Dashboard/Field'
import Control from '@/Components/Dashboard/Control'
import CheckRadioPicker from '@/Components/Dashboard/CheckRadioPicker'
import JbButton from '@/Components/Dashboard/JbButton'
import JbButtons from '@/Components/Dashboard/JbButtons'

export default {
    components: {
        BreezeDashboardLayout,
        Head,
        CardComponent,
        Notification,
        Field,
        Control,
        CheckRadioPicker,
        JbButton,
        JbButtons
    },
    props: {
        errors: Object,
        userPermissions: Object
    },
    data() {
        return {
            form: this.$inertia.form({
                name: '',
                guard_name: this.guard_name_options[0],
                permissions: [],
            }),
        }
    },
    setup() {

        const guard_name_options = [
            {id: 'web', label: 'Web'},
            {id: 'api', label: 'Api'}
        ];

        return {
            mdiAccount,
            mdiAccountMultipleOutline,
            mdiAt,
            mdiLink,
            mdiOpenInNew,
            mdiEmail,
            mdiAccountChildCircle,
            mdiAvTimer,
            mdiTranslate,
            mdiNumeric8BoxMultipleOutline,
            guard_name_options
        }
    },
    methods: {
        submit() {
            this.form.post(this.route('roles.store'))
        }
    }
}
</script>
